import React, { useState, useEffect } from 'react';
import { Modal, Table, message } from 'antd';
import Axios from 'axios';
import { url } from '../../config/global';

const DetailSPStockSupplier = ({ isVisible, onCancel, record, month, pageSize, token }) => {
  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const columns = [
    {
      title: 'Tipe',
      dataIndex: 'type',
      sorter: true,
    },
    {
      title: 'Tanggal',
      dataIndex: 'created_at',
      sorter: true,
    },
    {
      title: 'Std Pack',
      dataIndex: 'std_pack',
      sorter: true,
    },
    {
      title: 'Qty Kanban',
      dataIndex: 'qty_kanban',
      sorter: true,
    },
    {
      title: 'Surat Jalan',
      dataIndex: 'surat_jalan',
      sorter: true,
    },
    {
      title: 'DN IN',
      dataIndex: 'dn_in',
      sorter: true,
    },
    {
      title: 'DN OUT',
      dataIndex: 'dn_out',
      sorter: true,
    },
    {
      title: 'Keterangan',
      dataIndex: 'keterangan',
      sorter: true,
      render: (text) => text ?? '-',
    },
  ];

  const fetchHistoryData = async (pagination = { current: currentPage, pageSize: 10 }, sorter = {}) => {
    if (!record) return;
    setLoading(true);
    try {
      const params = {
        item_number: record.before_item,
        model: record.model,
        page: pagination.current,
        perpage: pagination.pageSize,
        sort: sorter.field || 'created_at',
        order: sorter.order || 'descend',
        year: month?.format('YYYY'),
        month: month?.format('MM'),
      };

      const res = await Axios.get(`${url}/stock-inventory/getDetail`, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setHistoryData(res.data.data);
      setTotal(res.data.total);
    } catch (err) {
      message.error('Gagal mengambil data detail history');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isVisible) {
      fetchHistoryData();
    }
  }, [isVisible, record]);

  const handleChange = (pagination, filters, sorter) => {
    fetchHistoryData(pagination, sorter);
    setCurrentPage(pagination.current);
  };

  return (
    <Modal visible={isVisible} onCancel={onCancel} footer={null} title={historyData.length > 0 ? `Detail Stock ${historyData[0].item_number} (${historyData[0].model})` : 'Detail Stock'} width="80%">
      <Table
        columns={columns}
        dataSource={historyData}
        loading={loading}
        onChange={handleChange}
        pagination={{
          current: currentPage,
          total: total,
        }}
        rowKey={(row) => row._id}
        scroll={{ x: 'max-content' }}
      />
    </Modal>
  );
};

export default DetailSPStockSupplier;
